import * as palette from "../palette";

import CssLayers from "../CssLayers";
import FocusOnMount from "../FocusOnMount";
import PropTypes from "prop-types";
import React from "react";
import { Value } from "react-powerplug";
import testId from "../testId";

/**
 * @param   {String}   currentValue
 * @param   {Function} onInsert
 * @param   {Function} onCancel
 * @returns {Function}
 */
function handleKeyDown(currentValue, onInsert, onCancel) {
  return event => {
    if (event.key === "Enter" && currentValue) {
      event.preventDefault();

      // TODO: validate properly
      if (/^https?:\/\/(.+)/i.test(currentValue)) {
        onInsert(currentValue);
      }
    }

    if (event.key === "Escape") {
      onCancel();
    }
  };
}

export default function LinkInput({ onInsert, onCancel }) {
  return (
    <Value initial="">
      {({ value, set }) => (
        <div
          css={{
            whiteSpace: "nowrap",
            zIndex: CssLayers.INLINE_TOOLBAR_LINK_INPUT,
            width: 250,
            height: 40,
          }}
        >
          <FocusOnMount>
            {({ innerRef }) => (
              <input
                {...testId("StandardInlineToolbar/toggle/link/input")}
                value={value}
                ref={innerRef}
                onChange={event => set(event.target.value)}
                spellCheck={false}
                onKeyDown={handleKeyDown(value, onInsert, onCancel)}
                placeholder="What's the URL?"
                css={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                  padding: 10,
                  width: "100%",
                  height: "100%",
                  color: "#ffffff",
                  "&::placeholder": {
                    color: palette.sealBlue,
                  },
                }}
              />
            )}
          </FocusOnMount>
        </div>
      )}
    </Value>
  );
}

LinkInput.propTypes = {
  onInsert: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
